@use "@fukuri-admins/ui/layout" as *;

.titleWrapper {
  display: flex;
  justify-content: flex-end;
}
